import React, { useCallback, useEffect, useState } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';

import FloatingButton from '../../../../../../components/FloatingButton';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import useForm from '../../../../../../helpers/useForm';
import Step4Validations from './Step4.validations';
import Step5 from './Step5';
import Step6 from './Step6';

const photos = [
  {
    title: 'Fotografías',
    content: <Step5 />,
    order: 6,
  },
  {
    title: 'Fotografías',
    content: <Step6 />,
    order: 7,
  },
];

const Step4 = () => {
  const {
    loading,
    step,
    goBack,
    nextStep,
    updateSinisterInspectionBody,
    sinister_inspection_body,
    STEPS,
    flowHasPhotos,
  } = useSinisterInspectionsContext();

  const [defaultValues] = useState({
    betweenStreets: sinister_inspection_body.betweenStreets,
    additionalInformation: sinister_inspection_body.additionalInformation,
  });

  const [budgetPhotos, setBudgetPhotos] = useState(
    sinister_inspection_body.budgetPhotos || false
  );

  const callNextStep = () => {
    if (budgetPhotos) {
      flowHasPhotos(budgetPhotos);
    } else {
      flowHasPhotos(budgetPhotos);
    }
    updateSinisterInspectionBody({
      ...values,
      budgetPhotos,
    });
    nextStep();
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    callNextStep,
    Step4Validations,
    defaultValues
  );

  return (
    <>
      {/* <Box display={loading ? 'block' : 'none'}>
                <Loader action={'Cargando denuncias'}></Loader>
            </Box> */}

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={4}>
            <Typography variant="h6">
              ¿Querés sumar información adicional?
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mb={2}>
            <Typography variant="subtitle2"> Entre calles </Typography>
            <TextField
              type="text"
              size="small"
              //error={Boolean(errors['betweenStreets'])}
              //helperText={errors['betweenStreets']}
              onChange={handleChange}
              fullWidth={true}
              name="betweenStreets"
              id="betweenStreets"
              placeholder="Ingresá las calles"
              variant="outlined"
              value={values.betweenStreets}
            />
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mb={2}>
            <Typography variant="subtitle2">Información adicional</Typography>
            <TextField
              name="additionalInformation"
              id="additionalInformation"
              multiline
              fullWidth
              size="medium"
              rows={8}
              placeholder="Ingresá tus comentarios"
              variant="outlined"
              value={values.additionalInformation}
              onChange={handleChange}
              // error={additionalInformation?.length > 1333}
              // helperText={
              //   additionalInformation?.length > 1333 &&
              //   'El relato del hecho no deberia superar los 1333 caracteres'
              // }
            />
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mb={2}>
            <FormControl component="fieldset">
              <FormGroup aria-label="position">
                <Grid>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={budgetPhotos}
                        color="primary"
                        onChange={(event) =>
                          setBudgetPhotos(event.target.checked)
                        }
                      />
                    }
                    label="Tengo fotos de mi presupuesto"
                    name="budgetPhotos"
                    id="budgetPhotos"
                  />
                </Grid>
              </FormGroup>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box my={4}>
            <FloatingButton
              onClick={callNextStep}
              //disabled={!selectedDate}
            >
              Continuar
            </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Step4;
